import { unit } from '@ant-design/cssinjs';
import { prepareComponentToken, prepareToken } from '.';
import { genSubStyleComponent } from '../../theme/internal';
const genBorderedStyle = token => {
  const {
    componentCls
  } = token;
  return {
    ["".concat(componentCls).concat(componentCls, "-bordered").concat(componentCls, "-disabled:not(").concat(componentCls, "-mini)")]: {
      '&, &:hover': {
        ["".concat(componentCls, "-item-link")]: {
          borderColor: token.colorBorder
        }
      },
      '&:focus-visible': {
        ["".concat(componentCls, "-item-link")]: {
          borderColor: token.colorBorder
        }
      },
      ["".concat(componentCls, "-item, ").concat(componentCls, "-item-link")]: {
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorder,
        ["&:hover:not(".concat(componentCls, "-item-active)")]: {
          backgroundColor: token.colorBgContainerDisabled,
          borderColor: token.colorBorder,
          a: {
            color: token.colorTextDisabled
          }
        },
        ["&".concat(componentCls, "-item-active")]: {
          backgroundColor: token.itemActiveBgDisabled
        }
      },
      ["".concat(componentCls, "-prev, ").concat(componentCls, "-next")]: {
        '&:hover button': {
          backgroundColor: token.colorBgContainerDisabled,
          borderColor: token.colorBorder,
          color: token.colorTextDisabled
        },
        ["".concat(componentCls, "-item-link")]: {
          backgroundColor: token.colorBgContainerDisabled,
          borderColor: token.colorBorder
        }
      }
    },
    ["".concat(componentCls).concat(componentCls, "-bordered:not(").concat(componentCls, "-mini)")]: {
      ["".concat(componentCls, "-prev, ").concat(componentCls, "-next")]: {
        '&:hover button': {
          borderColor: token.colorPrimaryHover,
          backgroundColor: token.itemBg
        },
        ["".concat(componentCls, "-item-link")]: {
          backgroundColor: token.itemLinkBg,
          borderColor: token.colorBorder
        },
        ["&:hover ".concat(componentCls, "-item-link")]: {
          borderColor: token.colorPrimary,
          backgroundColor: token.itemBg,
          color: token.colorPrimary
        },
        ["&".concat(componentCls, "-disabled")]: {
          ["".concat(componentCls, "-item-link")]: {
            borderColor: token.colorBorder,
            color: token.colorTextDisabled
          }
        }
      },
      ["".concat(componentCls, "-item")]: {
        backgroundColor: token.itemBg,
        border: "".concat(unit(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorBorder),
        ["&:hover:not(".concat(componentCls, "-item-active)")]: {
          borderColor: token.colorPrimary,
          backgroundColor: token.itemBg,
          a: {
            color: token.colorPrimary
          }
        },
        '&-active': {
          borderColor: token.colorPrimary
        }
      }
    }
  };
};
export default genSubStyleComponent(['Pagination', 'bordered'], token => {
  const paginationToken = prepareToken(token);
  return [genBorderedStyle(paginationToken)];
}, prepareComponentToken);